var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-remote-monitoring-indicator-trends',{on:{"on-create-link":_vm.onCreateHandler,"on-select-template":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }